<template>
  <div class=" " :class="disabled ? 'disabled' : 'enabled'">
    <div class="px-4 pb-4 flex items-center cursor-pointer relative" v-if="isLoading && !isFinished">
      <UploadIcon class="animate-pulse mr-1" size="20"></UploadIcon>
      <div class="text-small">Uploading file...</div>
    </div>
    <div class="px-4 pb-4 flex items-center cursor-pointer relative" v-if="!isLoading && isFinished">
      <CheckIcon class="animate-pulse mr-1" size="20"></CheckIcon>
      <div class="text-small">Upload successful!</div>
    </div>
<!--    <div class="" :class="{hovering: hovering}" :style="{backgroundImage: backgroundImage}" ref="uploader">-->
<!--      <input class="file-photo" type="file" @change="handleImage" @dragenter="hovering = true"-->
<!--             @dragleave="hovering = false" :disabled="disabled"/>-->
<!--    </div>-->
    <div class="px-4 pb-4 flex items-center cursor-pointer relative" ref="uploader">
      <ImageIcon class="w-4 h-4 mr-2"/>
      <span class="text-theme-1 dark:text-theme-10 mr-1"
      >Upload a file</span
      >
      (size limit 5MB)
<!--      <input-->
<!--          class="file-photo w-full h-full top-0 left-0 absolute opacity-0" type="file" @change="handleImage" @dragenter="hovering = true"-->
<!--          @dragleave="hovering = false" :disabled="disabled"-->
<!--      />-->
      <input
          type="file" @change="handleImage" @dragenter="hovering = true"
          @dragleave="hovering = false" :disabled="disabled"
      />
    </div>
  </div>
</template>

<style>
.uploader {
  position: relative;
  overflow: hidden;
  width: 300px;
  height: 250px;
  background-color: #f3f3f3;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  border: 2px dashed #e8e8e8;
}
.enabled .uploader.hovering {
  background-color: #bbb;
}
.enabled .uploader:hover {
  background-color: skyblue;
}
.upload-instructions {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
}
.file-photo {
  position: absolute;
  width: 300px;
  height: 400px;
  top: -50px;
  left: 0;
  z-index: 2;
  opacity: 0;
}
.enabled .file-photo {
  cursor: pointer;
}
.uploader img {
  position: absolute;
  width: 100%;
  top: -1px;
  left: -1px;
  z-index: 1;
  border: none;
}
</style>

<script>
import axios from "axios"
export default {
  props: ['value', 'disabled', 'type'],
  data() {
    return {
      hovering: false,
      preview: null,
      percentCompleted: 0,
      isLoading: false,
      isFinished: false
    }
  },
  methods: {
    uploadImage(file) {
      this.isLoading = true
      this.isLoading = false
      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", 75);
      axios.post(this.$upskill.trainerUpload+"/"+this.type,
          formData,
          {
            onUploadProgress: function(progressEvent) {
              let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
              console.log(percentCompleted)
            },
            headers: {
              'Content-Type': 'multipart/form-data',
              'X-Auth-Secret': localStorage.getItem("ctoken")
            }
          }
      ).then((res) => {
        this.isLoading = false
        this.isFinished = true
        this.$emit("uploaded", res.data)
      })
    },
    handleImage(event) {
      if (this.disabled) {
        return;
      }
      let files = event.target.files;
      if (files.length === 0){
        return;
      }
      let reader = new FileReader();
      reader.onload = (event) => {
        this.preview = event.target.result;
        this.$emit('input', files[0]);
        this.uploadImage(files[0])
      };
      reader.readAsDataURL(files[0]);
    }
  },

  computed: {
    backgroundImage() {
      let image = this.preview || this.value;
      if (!image) {
        return null;
      }
      return `url('${image}')`;
    }
  }
}
</script>
